const sim = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_SIM_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_SIM_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getSimComponent: state => state.component,
        getSimEdit: state => state.edit
    }
}

export default sim